// 简易离线队列：使用 localStorage 持久化，在线后自动同步
const STORAGE_KEY = 'JDBH_OFFLINE_QUEUE';

const readQueue = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const arr = JSON.parse(raw || '[]');
    return Array.isArray(arr) ? arr : [];
  } catch (_) {
    return [];
  }
};

const notifyQueueChange = (arr) => {
  try {
    const items = Array.isArray(arr) ? arr : [];
    const evt = new CustomEvent('offlineQueue:updated', { detail: { items, count: items.length } });
    window.dispatchEvent(evt);
  } catch (_) {
    // noop
  }
};

const writeQueue = (arr) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(arr));
  } catch (_) {}
  // 事件驱动通知 UI 刷新
  try { notifyQueueChange(arr); } catch (_) {}
};

export const listQueue = () => readQueue();

export const enqueue = (type, payload) => {
  const item = {
    id: `${type}_${Date.now()}_${Math.random().toString(36).slice(2,8)}`,
    type,
    payload,
    ts: Date.now()
  };
  const arr = readQueue();
  arr.push(item);
  writeQueue(arr);
  return item;
};

export const removeById = (id) => {
  const arr = readQueue().filter((x) => x.id !== id);
  writeQueue(arr);
};

export const clearQueue = () => writeQueue([]);

export const isOnline = () => {
  try { return navigator.onLine; } catch (_) { return true; }
};